// extracted by mini-css-extract-plugin
module.exports = {"shadow":"CheckboxOverride_shadow__2J1Db","checkbox":"CheckboxOverride_checkbox__h12Qs"};